import { Routes } from '@angular/router';

export const freelancerRoutes: Routes = [
  {
    path: '',
    loadComponent: () => import('./projects/projects.component').then((m) => m.ProjectsComponent),
    pathMatch: 'full',
  },
  {
    path: 'projects',
    loadComponent: () => import('./projects/projects.component').then((m) => m.ProjectsComponent),
  },
  {
    path: 'proposals',
    loadComponent: () =>
      import('./proposals/proposals.component').then((m) => m.ProposalsComponent),
  },
  {
    path: 'freelancers-list',
    loadComponent: () =>
      import('./components/freelancer-list/freelancer-list.component').then(
        (m) => m.FreelancerListComponent
      ),
  },
];
